import { GroupedGeoJSON } from "../../../../../../utilities/types";
import { PolygonElementParams, PointElementParams } from "./GeoPreviewMap.helpers";

export interface GeoPreviewMapProps {
	inputData: GroupedGeoJSON[];
	groupIndex: number;
}

export interface FeaturePopupData {
	position: google.maps.LatLngLiteral;
	properties: Record<string, unknown>;
}

export interface ProcessedFeatureData {
	polygonData: PolygonElementParams[];
	pointData: PointElementParams[];
	totalFeatures: number;
	allCoordinates: google.maps.LatLngLiteral[];
}

export interface GeoPreviewMapViewModel {
	// State
	mapsLibrary: google.maps.MapsLibrary | null;
	activePopup: FeaturePopupData | null;

	// Computed values
	processedFeatures: ProcessedFeatureData;

	// Handlers
	onFeatureClick: (position: google.maps.LatLngLiteral, properties: Record<string, unknown>) => void;
	handleMapClick: () => void;
}

// Constants
export const WARNING_THRESHOLD = 200;
export const MAX_FEATURES = 500;

export const COLORS = ["#4CAF50", "#2196F3", "#FF9800", "#9C27B0", "#E91E63", "#00BCD4", "#FF5722", "#795548"];
